import { Page } from '../../layout/Page.tsx'
import { Button } from '../../newComponents/Button/Button.tsx'
import { useAuth } from '../../AuthProvider.ts'

const Elements = () => {
	const { refreshAuth } = useAuth()

	return (
		<Page title="Elements" breadcrumbs="Elements" description="Elements">
			<Button onClick={refreshAuth}>Refresh tokens</Button>
		</Page>
	)
}

export default Elements
